import flattenMessages from '../../../helpers/flattenMessages';

export default {
  en: flattenMessages({}, 'cookies'),
  ja: flattenMessages({}, 'cookies'),
};
